import Auth from '@/api/Auth';
import { createAuthStore } from '@onereach/auth-ui-module';

export const useAuthStore = createAuthStore(Auth);

export default useAuthStore;
